<template>
  <div class="masterPage">
    <section class="wrapper">
      <HeaderComponent />
      <SearchComponent />
      <section class="cw-main" >


        <PlansComponent />
        <PaginationComponent />
      </section>
      <FooterComponent />
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import SearchComponent from '@/components/SearchComponent.vue';
import PaginationComponent from '@/components/PaginationComponent.vue';
import PlansComponent from '@/components/PlansComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';
import HeaderComponent from '@/components/HeaderComponent';


export default {
  name: 'MasterPage',
  components: {
    HeaderComponent,
    SearchComponent,
    PlansComponent,
    PaginationComponent,
    FooterComponent,

  },


};
</script>

